import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista de Filmes
 * @param {Function} setFilmes función para establecer la lista de Filmes
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getTags = (setTags, setError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Tags", {
            headers: {
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setTags(response.data); // Establece la lista de Filmes en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};